var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30.5 30.4",
    style: {
      enableBackground: "new 0 0 30.5 30.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12.9,
    y: -3.3,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 15.1323 -6.0868)",
    className: "st0",
    width: 4,
    height: 37
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.6,
    y: -3.3,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 37.4304 14.9416)",
    className: "st0",
    width: 4,
    height: 37
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCross);
export default __webpack_public_path__ + "static/media/white_cross.fba71a2f39c811c629d59886a38b0952.svg";
export { ForwardRef as ReactComponent };